import { EventsMap } from 'redux-beacon';
import {
  getAddToCartEvent,
  getClearCartEvent,
  getNavigationEvent,
  getRemoveFromCartEvent,
  getSearchEvent,
  getViewCartEvent
} from 'store/googleTagManager/events';
import {
  GTM_REMOVE_FROM_CART,
  GTM_CLEAR_CART,
  GtmCartItemAction,
  GTM_ADD_TO_CART,
  GTM_VIEW_CART,
  GTM_SEARCH,
  GtmSearchAction,
  GTM_INTERNAL_NAV_CLICK,
  GtmInternalNavAction,
  GTM_VOYADO_CART_UPDATE,
  GtmVoyadoCartUpdateAction
} from 'store/googleTagManager/actions';
import { PageState } from 'models/PageState';
import { getVoyadoCartEvent } from '../events/voyadoEvents';

// Header has its own events map so that we can push events
// to dataLayer on non-react pages as well, example: Contact us page, About us page
export const HeaderEventsMap: EventsMap = {
  [GTM_CLEAR_CART]: () => {
    return getClearCartEvent();
  },
  [GTM_REMOVE_FROM_CART]: (action: GtmCartItemAction, prevState: PageState) => {
    return getRemoveFromCartEvent(action, prevState);
  },
  [GTM_ADD_TO_CART]: (action: GtmCartItemAction, prevState: PageState) => {
    return getAddToCartEvent(action, prevState);
  },
  [GTM_VIEW_CART]: (_, prevState: PageState) => {
    return getViewCartEvent(prevState);
  },
  [GTM_SEARCH]: (action: GtmSearchAction) => {
    return getSearchEvent(action);
  },
  [GTM_INTERNAL_NAV_CLICK]: (action: GtmInternalNavAction, prevState: PageState) => {
    return getNavigationEvent(action, prevState.appShell, 'internal_navigation');
  },
  [GTM_VOYADO_CART_UPDATE]: (action: GtmVoyadoCartUpdateAction, state: PageState) => {
    return getVoyadoCartEvent(action, state);
  }
};
